<div class="kt-header__brand kt-grid__item pr-5" id="kt_header_brand">
  <div class="kt-header__brand-logo">
    <a routerLink="/">
      @if (!appSession.tenant || !appSession.tenant.HasLogo()) {
        <img class="brandLogoUpm" src="/assets/common/images/upm-logo.svg" alt="logo" height="75" style="cursor: pointer;"/>
      }
      @if (appSession.tenant && appSession.tenant.HasLogo()) {
<img [src]="remoteServiceBaseUrl + '/TenantCustomization/GetTenantLogo?skin=' + currentTheme.baseSettings.menu.asideSkin + '&tenantId=' + appSession.tenant.id + '&id=' + appSession.tenant.HasLogo()" alt="logo" height="38" />
}
        </a>
    </div>
</div>
